import * as React from 'react'

import type { CommercialRoi } from '@sdr-agend/admin-schemas'
import { formatCurrencyBRL } from '@/lib/format'

/**
 * "Impacto Financeiro / ROI" (Story 10.8, 2026-07-30, user request, AC7) —
 * custo de IA/WhatsApp (USD) convertido pra BRL na taxa configurada
 * (`system_settings.usd_to_brl_rate`). Estimativa, não conciliação
 * financeira exata (mesmo espírito de `CostsSummaryPanel`).
 */
export interface CommercialRoiPanelProps {
  data: CommercialRoi
}

function formatMultiplier(n: number | null): string {
  return n === null ? 'N/A' : `${n.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}x`
}

export function CommercialRoiPanel({ data }: CommercialRoiPanelProps): React.ReactElement {
  const rows = [
    { key: 'leads', label: 'Leads Gerados', value: data.leadsGerados.toLocaleString('pt-BR') },
    { key: 'cost', label: 'Custo Estimado', value: formatCurrencyBRL(data.custoEstimadoBRL) },
    {
      key: 'costPerBooking',
      label: 'Custo por Agendamento',
      value: data.custoPorAgendamentoBRL === null ? 'N/A' : formatCurrencyBRL(data.custoPorAgendamentoBRL),
    },
    { key: 'roi', label: 'Múltiplo de ROI', value: formatMultiplier(data.roiMultiplier) },
  ]

  return (
    <div data-testid="commercial-roi-panel">
      <div className="grid grid-cols-2 gap-3">
        {rows.map((row) => (
          <div key={row.key} className="rounded-md border p-2.5" data-testid={`commercial-roi-${row.key}`}>
            <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{row.label}</p>
            <p className="text-lg font-semibold tabular-nums">{row.value}</p>
          </div>
        ))}
      </div>
      <p className="mt-3 text-[11px] text-muted-foreground" data-testid="commercial-roi-note">
        Estimativa — custo de IA/WhatsApp convertido à taxa de {data.usdToBrlRate.toLocaleString('pt-BR')}{' '}
        (USD→BRL), não é conciliação financeira exata.
      </p>
    </div>
  )
}

export default CommercialRoiPanel
